/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {





  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


        // add custom media query sizes for Foundation Interchange
        Foundation.Interchange.SPECIAL_QUERIES.smallretina = 'only screen and (min-width: 1px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1px) and (min-resolution: 192dpi), only screen and (min-width: 1px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.mediumretina = 'only screen and (min-width: 641px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 641px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 641px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 641px) and (min-device-pixel-ratio: 2), only screen and (min-width: 641px) and (min-resolution: 192dpi), only screen and (min-width: 641px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.largeretina = 'only screen and (min-width: 1025px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1025px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (min-resolution: 192dpi), only screen and (min-width: 1025px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.xlargeretina = 'only screen and (min-width: 1921px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1921px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (min-resolution: 192dpi), only screen and (min-width: 1921px) and (min-resolution: 2dppx)';

        // init Foundation JavaScript
        $(document).foundation();

        // add plz pattern for Foundation Abide
        Foundation.Abide.defaults.patterns.plz = /^([0]{1}[1-9]{1}|[1-9]{1}[0-9]{1})[0-9]{3}$/;

        // set default Sticky size for Foundation Sticky
        Foundation.Sticky.defaults.stickyOn = 'large';

        // Mobile Menu
        Foundation.DropdownMenu.defaults.closeOnClick = true;

        if ($('body').hasClass('no-js')) {
          $('body').removeClass('no-js').addClass('js');
        }

        // change body class on scroll
        $(window).scroll(function() {
          if ($(this).scrollTop() > 50) {
            $('body').addClass('solid-header');
          } else {
            $('body').removeClass('solid-header');
          }
        });

        // add no-touch class for desktop browsers
        var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
        if (!touchsupport) {
            document.documentElement.className += " no-touch ";
        }

        // read-more controls
        $('.read-more-button').on('click', function (e) {
          $(this).prev('.read-more-content').prev('.read-more-dots').addClass('hide');
          $(this).find('.read-more-show-text').addClass('hide');
          $(this).find('.read-more-hide-text').removeClass('hide');
        });        
        $('.read-more-content').on('on.zf.toggler', function() {
          //$(this).prev('.read-more-dots').addClass('hide');
          //$(this).next('.read-more-button').find('.read-more-show-text').addClass('hide');
          //$(this).next('.read-more-button').find('.read-more-hide-text').removeClass('hide');
        });    
        $('.read-more-content').on('off.zf.toggler', function() {
          $(this).prev('.read-more-dots').removeClass('hide');
          $(this).next('.read-more-button').find('.read-more-show-text').removeClass('hide');
          $(this).next('.read-more-button').find('.read-more-hide-text').addClass('hide');
        });              

       // var $setter = $(".artwork-slider-image-wrap img");
        //console.log($setter.width);
        //$(this).parent().closest(".single-slider").css("width", $setter.width()+"px");


          $('.slider-normal').slick({

            infinite: true,
            speed: 1000,
            centerMode: true,
            variableWidth: true,
           autoplay: true,
            lazyLoad: 'ondemand',
            arrows: false,
            asNavFor: '.slider-normal-nav',
            responsive: [
              {

                breakpoint: 992,
                settings: {
                  infinite: true,
                  speed: 1000,
                  centerMode: true,
                  variableWidth: true,
                  arrows: true,
                autoplay: true
                }
              }
            ]
          });


        $(".slider-normal-nav").slick({
          asNavFor: '.slider-normal',
          infinite: true,
          speed: 200,
          fade: true
        });







        $('.slider-default').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          lazyLoad: 'ondemand',
          autoplay: false,
          pauseOnHover: false,
          //fade: true,
          speed: 500,
          //cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
          //autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });


        $('.slider-row').slick({
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          lazyLoad: 'ondemand',
          dots: true,
          autoplay: false,
          pauseOnHover: false,
          fade: false,
          customPaging : function(slider, i) {
            var thumb = $(slider.$slides[i]).data();
            return '<span class="normal">'+(i+1)+'</span>';
          },
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

        var numSlides = $('.slick-dots li').length;
        $( ".slick-dots li:last-child" ).after( '<span class="total"> / '+ numSlides +'</span>' );
        $('.slick-prev').appendTo(".slick-dots");
        $('.slick-next').appendTo(".slick-dots");


          $('.slider-gif').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            fade: true,
            speed: 0,
            pauseOnHover: false,
            autoplaySpeed: 500
          });


        $('.slider-autoplay').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          lazyLoad: 'ondemand',
          autoplay: true,
          pauseOnHover: false,
          fade: true,
          autoplaySpeed: 1000
        });


        //$(".wpcf7-submit").click(function() {
        //  $('html,body').animate({
        //        scrollTop: $(".wpcf7").offset().top - 90},
        //      'fast');
        //});

        document.addEventListener( 'wpcf7invalid', function( event ) {
          setTimeout( function() {
            $('html').stop().animate({
              scrollTop: $('.wpcf7-not-valid').eq(0).offset().top - 140,
            }, 500, 'swing');
          }, 100);
        }, false );

       // document.addEventListener( 'wpcf7mailsent', function( event ) {
        //   $(".section-inner").find('h1').hide();
        //  $(".section-inner").find('p').hide();
       //   $(".section-inner").find(".shadow").css("border", "none !important");
      //    $(".section-inner").find(".shadow").css("box-shadow", "none");
      //  }, false );


        $(window).scroll(function(){
          if ($(window).scrollTop() >= 100) {
            $('.fixed-header').addClass('fixed-visible');
          }
          else {
            $('.fixed-header').removeClass('fixed-visible');
          }
        });

        if ($(window).scrollTop() >= 100) {
          $('.fixed-header').addClass('fixed-visible');
        }
        else {
          $('.fixed-header').removeClass('fixed-visible');
        }



        $(".trigger-mobile-menu").click(function(){
          $(".mobile-menu").addClass("show-mobile-menu");
          $(".body-overlay").show("fast");
          $("body").css({
            'right':'125px',
            'transition' : 'all 0.2s'
          });
        });

        $(".close-mobile-menu, .body-overlay").click(function(){
          $(".mobile-menu").removeClass("show-mobile-menu");
          $(".body-overlay").hide("fast");
          $("body").css({
            'right':'0',
            'transition' : 'all 0.2s'
          });
        });

       /*   $('.wpcf7-date').datepicker();

          $('.wpcf7-date').focus(function(){
            $('.wpcf7-date').datepicker('show');
          });

          $('.wpcf7-date').click(function(){
            $('.wpcf7-date').datepicker('show');
          });
//$('#ui-datepicker-div').show();
          $('.wpcf7-date').datepicker('show');



        $('.wpcf7-date').focus(function(){
          $('.wpcf7-date').datepicker('show');
        });

*/








        // Form validation
        $(".standard-form").bind("submit",function(e) {
          e.preventDefault();
          console.log("submit intercepted");
          return false;
        });
        $(".standard-form").bind("invalid.zf.abide", function(ev,elem) {
          console.log("Field "+elem.attr('name')+" is invalid");
          var errorCount = $(this).find('[data-invalid]').length;
          if (errorCount===0) {
            $("#error-message").hide();
          }
        });
        $(".standard-form").bind("valid.zf.abide", function(ev,elem) {
          console.log("Field "+elem.attr('name')+" is valid");
          var errorCount = $(this).find('[data-invalid]').length;
          if (errorCount!==0) {
            $("#error-message").show();
            $("#error-count").html(errorCount);
          } else {
            $("#error-message").hide();
          }
        });
        $(".standard-form").bind("forminvalid.zf.abide", function(e,target) {
          console.log("form is invalid");
        });
        $(".standard-form").bind("formvalid.zf.abide", function(e,target) {
          console.log("form is valid");
          var formData = 'action=standardFormAction&post_id=' + my_ajax_object.post_id + '&' + $(this).serialize();

          $.ajax({
            url: my_ajax_object.ajax_url, // Let WordPress figure this url out...
            type: 'POST',
            dataType: 'JSON', // Set this so we don't need to decode the response...
            data: formData, // One-liner form data prep...
            beforeSend: function () {
              // You could do an animation here...
            },
            error: function () {
              console.log('error function fired');
            },
            success: function (data) {
              console.log(data.status);
              $("#ajaxoutput").html(data);
              if (data.status === 'success') {
                $(".standard-form").hide();
                $('#thank-you-message').fadeIn(300);
                $(window).trigger('resize');
              } else {
                console.log('success error');
              }
            },
            complete: function() {
              //console.log('Complete');
            }
          });
          return false;
        });


          $('.teaser-boxes').each(function () {
              if ( $(this).children().length == 1) {
                  $(this).css('justify-content','center');
              }
          });

          $('.teaser-boxes').each(function () {
              if ( $(this).children().length == 2) {
                  $(this).css('justify-content','center');
              }
          });

          $('.teaser-boxes').each(function () {
              if ( $(this).children().length == 5) {
                  $(this).css('justify-content','start');
              }
          });

          $('.teaser-boxes').each(function () {
              if ( $(this).children().length == 8) {
                  $(this).css('justify-content','start');
              }
          });

          $('.teaser-boxes').each(function () {
              if ( $(this).children().length == 11) {
                  $(this).css('justify-content','start');
              }
          });



        var mafs = $("#my-ajax-filter-search");
        var mafsForm = mafs.find("form");

        mafsForm.submit(function(e){
          e.preventDefault();

          if(mafsForm.find("#search").val().length !== 0) {
            var search = mafsForm.find("#search").val();
          }
          if(mafsForm.find("#year").val().length !== 0) {
            var year = mafsForm.find("#year").val();
          }
          if(mafsForm.find("#rating").val().length !== 0) {
            var rating = mafsForm.find("#rating").val();
          }
          if(mafsForm.find("#language").val().length !== 0) {
            var language = mafsForm.find("#language").val();
          }
          if(mafsForm.find("#genre").val().length !== 0) {
            var genre = mafsForm.find("#genre").val();
          }

          var data = {
            action : "my_ajax_filter_search",
            search : search,
            year : year,
            rating : rating,
            language : language,
            genre : genre
          }

          $.ajax({
            url : SiteParameters.ajax_url,
            data : data,
            success : function(response) {
              mafs.find("ul").empty();
              if(response) {
                for(var i = 0 ;  i < response.length ; i++) {
                  var html  = "<li id='movie-" + response[i].id + "'>";
                  html += "  <a href='" + response[i].permalink + "' title='" + response[i].title + "'>";
                  html += "      <img src='" + response[i].poster + "' alt='" + response[i].title + "' />";
                  html += "      <div class='movie-info'>";
                  html += "          <h4>" + response[i].title + "</h4>";
                  html += "          <p>Year: " + response[i].year + "</p>";
                  html += "          <p>Rating: " + response[i].rating + "</p>";
                  html += "          <p>Language: " + response[i].language + "</p>";
                  html += "          <p>Director: " + response[i].director + "</p>";
                  html += "          <p>Genre: " + response[i].genre + "</p>";
                  html += "      </div>";
                  html += "  </a>";
                  html += "</li>";
                  mafs.find("ul").append(html);
                }
              } else {
                var html  = "<li class='no-result'>No matching movies found. Try a different filter or search keyword</li>";
                mafs.find("ul").append(html);
              }
            }
          });
        });











        var delayTime = 2000;

        $(".more-catalouge-items").click(function () {
          $(this).hide();

          setTimeout(function(){
            $(".more-catalouge-items").show()
          }, delayTime);

        });



// Pages More Order
        $(".main-pages .pages").appendTo($(".main-pages .current"));


        $(".main-pages .pages").on("click", function(){
          $(".dropdown-pages, .main-pages .pages, .main-pages-bg, .close-button-pages").toggleClass("active");
          $("body").toggleClass("noscroll");
        });

        $(".main-pages-bg, .close-button-pages ").on("click", function(){
          $(".dropdown-pages, .main-pages .pages, .dropdown-lang, .main-pages-bg, .close-button-pages").removeClass("active");
          $("body").removeClass("noscroll");
        });


// Load More
        $('.more-catalouge-items-off').click(function(){

          var button = $(this),
              data = {
                'action': 'loadmore',
                'query': load_loadmore_params.posts, // that's how we get params from wp_localize_script() function
                'page' : load_loadmore_params.current_page
              };

          $.ajax({ // you can also use $.post here
            url : load_loadmore_params.ajaxurl, // AJAX handler
            data : data,
            type : 'POST',
            beforeSend : function ( xhr ) {
              console.log("test-before-send");
              button.text('...'); // change the button text, you can also add a preloader image
              MagicZoom.refresh('zoom-api');
              MagicZoom.start('zoom-api');
              MagicZoom.refresh();
            },
            success : function( data ){
              console.log("test-success");
              if( data ) {
               // button.text( 'More posts' ).prev().after(data); // insert new posts


                if ( load_loadmore_params.current_page == load_loadmore_params.max_page )
                  button.remove(); // if last page, remove the button

                // you can also fire the "post-load" event here if you use a plugin that requires it
                // $( document.body ).trigger( 'post-load' );
              } else {
                button.remove(); // if no data, remove the button as well
              }
            }
          });
        });

        //detects the start of an ajax request being made
        $(document).on("sf:ajaxstart", ".searchandfilter", function(){
          console.log("ajax start");

        });

//detects when the ajax request has finished and the content has been updated
// - add scripts that apply to your results here
        $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
          console.log("ajax complete");
          MagicZoom.refresh();


          $('.chosen-drop').on('click','li',function(e){
            e.preventDefault();
            $( ".searchandfilter" ).submit();
          });

          $( ".sf-field-search" ).append( "<i class='icon-search'></i>" );


          $('.sf-input-text').keypress(function(event){
            if(event.keyCode == 13){
              $( ".searchandfilter" ).submit();
            }
          });

          $('.sf-input-select').change(function(){
            $( ".searchandfilter" ).submit();
          });


          $('.sf-field-search').on('click','i',function(e){
            e.preventDefault();
            $( ".searchandfilter" ).submit();

          });
        });

//an event fired when S&F is initialised and S&F scripts have been loaded
        $(document).on("sf:init", ".searchandfilter", function(){
          console.log("S&F JS initialised");
        });

//depending on where you add your JS, sometimes its necessary to wrap the above events in a function (as is standard practice):
        (function ( $ ) {
          "use strict";

          $(document).on("sf:init", ".searchandfilter", function(){
            console.log("S&F JS initialised");
          });
        }(jQuery));


        /* Toggle category item */
        $('.chosen-drop').on('click','li',function(e){
          e.preventDefault();
          $( ".searchandfilter" ).submit();
        });

        $('.sf-input-text').keypress(function(event){
          if(event.keyCode == 13){
            $(".sf-input-select").val($(".sf-level-0" ).val());
            $('.sf-input-select').trigger('change');
            $( ".searchandfilter" ).submit();
          }
        });

        $('.sf-input-select').change(function(){
          $( ".searchandfilter" ).submit();
      });



        $( ".sf-field-search" ).append( "<i class='icon-search'></i>" );


        $('.sf-field-search').on('click','i',function(e){
          $(".sf-input-select").val($(".sf-level-0" ).val());
          $('.sf-input-select').trigger('change');

          e.preventDefault();
          $( ".searchandfilter" ).submit();
        });

        // Remember catalogue item
        function ajax_remember_catalogue_item (currentUserID, currentItemID) {
          var $current_remember_button = $('[data-current-catalogue-item-id="' + currentItemID + '"].user-button-wrap .remember-catalogue-item-button');
          $.ajax({
            url : SiteParameters.ajax_url,
            type : 'GET',
            dataType: 'html',
            data: ({
              action: 'remember_catalogue_item',
              currentUserID: currentUserID,
              currentItemID: currentItemID,
              currentpostid: SiteParameters.post_id
            }),      
            beforeSend: function (xhr) {
              
            },
            success: function(data){
              if(data) { 
                var parsedData = jQuery.parseJSON(data);
                var current_remember_items_count = parsedData.current_remember_items_count;
                var current_remember_button_text = parsedData.current_remember_button_text;
                if (parsedData.current_remember_status === 'remember'){
                  $current_remember_button.find('.icon').removeClass('icon-heart-empty').addClass('icon-heart');
                  $current_remember_button.find('.button-text').html(current_remember_button_text);
                } 
                if (parsedData.current_remember_status === 'unremember'){
                  $current_remember_button.find('.icon').removeClass('icon-heart').addClass('icon-heart-empty');
                  $current_remember_button.find('.button-text').html(current_remember_button_text);
                  $('.bookmarks-catalogue-section .user-button-wrap[data-current-catalogue-item-id="' + currentItemID + '"]').closest('.catalogue-item').slideUp();
                }  
                $('.remember-items-counter .remember-items-count').html(current_remember_items_count); 
                $('.bookmarks-catalogue-section .search-items-count').html(current_remember_items_count);
                if (current_remember_items_count > 0) {
                  $('.bookmarks-message-wrap').removeClass('show').addClass('hide');
                  $('.bookmarks-catalogue-section .search-counter').removeClass('hide').addClass('show');
                } else {
                  $('.bookmarks-message-wrap').removeClass('hide').addClass('show');
                  $('.bookmarks-catalogue-section .search-counter').removeClass('show').addClass('hide');
                }                                               
              }
            },
            error: function(data) {
              console.log("Error: " + data);
              return false;
            },
            complete: function() {    
              //console.log("Complete");
              $current_remember_button.removeClass('sending');
              $current_remember_button.find('.icon-spinner').remove();                     
            }
          });
        } 

        $('.remember-catalogue-item-button').click(function(){
          if ($(this).hasClass('trigger-log-in-register-popup')) {
            $('#log-in-register-popup').foundation('open');
          } 
        });


        $('.highlights-normal, .post-items').colcade({
          columns: '.grid-col',
          items: '.item'
        });


        $('.bidder-logged-in .remember-catalogue-item-button').click(function(){
          var currentUserID = $(this).closest('.user-button-wrap').attr("data-current-user-id");
          var currentItemID = $(this).closest('.user-button-wrap').attr("data-current-catalogue-item-id");
          $(this).append( ' <i class="icon-spinner"></i>' );
          $(this).addClass('sending');
          ajax_remember_catalogue_item(currentUserID, currentItemID);
        });

        // Search request form
        $("#search-request-form").bind("submit",function(e) {
          e.preventDefault();
          return false;
        });

        $("#search-request-form").bind("formvalid.zf.abide", function(e,target) {
          var currentUserID = $(this).attr("data-current-user-id");
          var currentItemID = $(this).attr("data-current-search-request-item-id");
          var $current_search_request_section = $('.user-button-wrap[data-current-search-request-item-id="' + currentItemID + '"]').closest('.search-requests-section');
          var $current_search_request_item = $('.user-button-wrap[data-current-search-request-item-id="' + currentItemID + '"]').closest('.search-request-item');
          var $current_button_wrap = $('[data-current-search-request-item-id="' + currentItemID + '"].user-button-wrap');
          var $current_search_request_button = $('[data-current-search-request-item-id="' + currentItemID + '"].user-button-wrap .search-request-button');
          var $current_submit_button = $(this).find('.submit-search-request-button');
          var formData;

          formData = $(this).serialize()
          +'&action=search_request_form_action' 
          +'&currentUserID=' + currentUserID;

          if (currentItemID !== undefined) {
            formData = formData +'&currentItemID=' + currentItemID; 
          }

          $.ajax({
            url: SiteParameters.ajax_url,
            type: 'POST',
            dataType: 'html',
            data: formData,            
            beforeSend: function() {
              $current_submit_button.append( ' <i class="icon-spinner"></i>' );
              $current_submit_button.addClass('sending');
            },
            error: function() {
              console.log('error function fired');
            },
            success: function(data) {
              if(data) { 
                var parsedData = jQuery.parseJSON(data);
                if (parsedData.status === 'success'){
                  var current_search_requests_count = parsedData.current_search_requests_count;
                  $('.search-requests-count').html(current_search_requests_count);
                  $('.search-requests-section .search-items-count').html(current_search_requests_count);
                  if (parsedData.current_item_status === 'new_item'){
                    var $dynamicElement = $('.empty-item-wrap .search-request-item').clone().insertBefore('.empty-item-wrap').addClass('cloned-item');
                    $dynamicElement.find('.search-request-item-desciption').html(parsedData.current_search_request_text);
                    $dynamicElement.find('.user-button-wrap').attr('data-current-search-request-item-id', parsedData.new_search_request_post_id);

                    $dynamicElement.find('.search-request-button').click(function(){
                      var currentUserID = $(this).closest('.user-button-wrap').attr("data-current-user-id");
                      var currentItemID = $(this).closest('.user-button-wrap').attr("data-current-search-request-item-id");
                      $("#search-request-form").attr("data-current-user-id", currentUserID);
                      $("#search-request-text").val('');
                      $("#search-request-form").attr("data-current-search-request-item-id", currentItemID);
                      $("#search-request-form").removeClass('hide').addClass('show');
                      $('#search-request-form-success').removeClass('show').addClass('hide');                      
                      ajax_load_search_request_text ( currentItemID );               
                    });

                    if (current_search_requests_count > 0) {
                      $('.search-request-message-wrap').removeClass('show').addClass('hide');
                      $('.search-requests-section .search-counter').removeClass('hide').addClass('show');
                    } else {
                      $('.search-request-message-wrap').removeClass('hide').addClass('show');
                      $('.search-requests-section .search-counter').removeClass('show').addClass('hide');
                    }                     
                  } else {
                    $current_search_request_item.find('.search-request-item-desciption').html(parsedData.current_search_request_text);
                  }
                } else {
                  console.log('success error');
                }                               
              }              
            },
            complete: function() {
              $current_submit_button.removeClass('sending');
              $current_submit_button.find('.icon-spinner').remove(); 
              $("#search-request-form").removeClass('show').addClass('hide');
              $("#search-request-form-success").removeClass('hide').addClass('show');              
            }
          });
          return false;
        });  

        $('.bidder-logged-in .search-request-button').click(function(){
          var currentUserID = $(this).closest('.user-button-wrap').attr("data-current-user-id");
          var currentItemID = $(this).closest('.user-button-wrap').attr("data-current-search-request-item-id");
          $("#search-request-form").attr("data-current-user-id", currentUserID);
          $("#search-request-text").val('');

          if ( $(this).hasClass('new-item-button') ) {
            $("#search-request-form").attr("data-current-search-request-item-id", '');
          } else {
            $("#search-request-form").attr("data-current-search-request-item-id", currentItemID);
            ajax_load_search_request_text ( currentItemID );
          }

          $("#search-request-form").removeClass('hide').addClass('show');
          $('#search-request-form-success').removeClass('show').addClass('hide');
                           
        });

        function ajax_load_search_request_text ( itemID ) {

          $.ajax({
            url : SiteParameters.ajax_url,
            type : 'POST',
            dataType: 'html',
            data: ({
              action: 'load_search_request_text',
              currentitemID: itemID
            }),      
            beforeSend: function (xhr) {
              
            },
            success: function(data){
              if(data) { 
                var parsedData = jQuery.parseJSON(data);
                if (parsedData.output){
                  $("#search-request-text").val(parsedData.output);
                }              
              }
            },
            error: function(data) {
              console.log("Error: " + data);
              return false;
            },
            complete: function() {    
              //console.log("Complete");                         
            }
          });
        } 

        // Remove search_request
        function ajax_remove_search_request (currentUserID, currentItemID) {
          var $current_remove_search_request_button = $('[data-current-search-request-item-id="' + currentItemID + '"].user-button-wrap .remove-search-request-button');
          $.ajax({
            url : SiteParameters.ajax_url,
            type : 'GET',
            dataType: 'html',
            data: ({
              action: 'remove_search_request',
              currentUserID: currentUserID,
              currentItemID: currentItemID,
              currentpostid: SiteParameters.post_id
            }),      
            beforeSend: function (xhr) {
              
            },
            success: function(data){
              if(data) { 
                var parsedData = jQuery.parseJSON(data);
                var current_search_requests_count = parsedData.current_search_requests_count;
                $('.search-requests-section .user-button-wrap[data-current-search-request-item-id="' + currentItemID + '"]').closest('.search-request-item').slideUp();  
                $('.search-requests-count').html(current_search_requests_count);
                $('.search-requests-section .search-items-count').html(current_search_requests_count);
                if (current_search_requests_count > 0) {
                  $('.search-request-message-wrap').removeClass('show').addClass('hide');
                  $('.search-requests-section .search-counter').removeClass('hide').addClass('show');
                } else {
                  $('.search-request-message-wrap').removeClass('hide').addClass('show');
                  $('.search-requests-section .search-counter').removeClass('show').addClass('hide');
                }                                               
              }
            },
            error: function(data) {
              console.log("Error: " + data);
              return false;
            },
            complete: function() {    
              //console.log("Complete");
              $current_remove_search_request_button.removeClass('sending');
              $current_remove_search_request_button.find('.icon-spinner').remove();                     
            }
          });
        } 

        $('.bidder-logged-in .remove-search-request-button').click(function(){
          var currentUserID = $(this).closest('.user-button-wrap').attr("data-current-user-id");
          var currentItemID = $(this).closest('.user-button-wrap').attr("data-current-search-request-item-id");
          $(this).append( ' <i class="icon-spinner"></i>' );
          $(this).addClass('sending');
          ajax_remove_search_request(currentUserID, currentItemID);
        });


        $('.special-bid-button').click(function(){
          if ($(this).hasClass('trigger-special-bid-popup')) {
            $('#special-bid-popup').foundation('open');
          } 
        });

        // Place bid form
        $("#place-bid-form").bind("submit",function(e) {
          e.preventDefault();
          return false;
        });

        $("#place-bid-form").bind("formvalid.zf.abide", function(e,target) {
          var currentUserID = $(this).attr("data-current-user-id");
          var currentItemID = $(this).attr("data-current-catalogue-item-id");
          var currentBidID = $(this).attr("data-bid-id");
          var $current_catalogue_section = $('.user-button-wrap[data-current-catalogue-item-id="' + currentItemID + '"]').closest('.catalogue-section');
          var $current_catalogue_item = $('.user-button-wrap[data-current-catalogue-item-id="' + currentItemID + '"]').closest('.catalogue-item');
          var $current_button_wrap = $('[data-current-catalogue-item-id="' + currentItemID + '"].user-button-wrap');
          var $current_place_bid_button = $('[data-current-catalogue-item-id="' + currentItemID + '"].user-button-wrap .place-bid-button');
          var $current_submit_button = $(this).find('.submit-bid-button');
          var formData;

          formData = $(this).serialize()
          +'&action=place_bid_form_action' 
          +'&currentUserID=' + currentUserID 
          +'&currentItemID=' + currentItemID;

          if (currentBidID !== undefined) {
            formData = formData +'&currentBidID=' + currentBidID; 
          }

          $.ajax({
            url: SiteParameters.ajax_url,
            type: 'POST',
            dataType: 'html',
            data: formData,            
            beforeSend: function() {
              $current_submit_button.append( ' <i class="icon-spinner"></i>' );
              $current_submit_button.addClass('sending');
            },
            error: function() {
              console.log('error function fired');
            },
            success: function(data) {
              if(data) { 
                var parsedData = jQuery.parseJSON(data);
                if (parsedData.status === 'success'){
                  var current_user_bids_count = parsedData.current_user_bids_count;
                  $('.user-bids-count').html(current_user_bids_count);
                  if (current_user_bids_count > 0) {
                    $('.user-bids-counter').addClass('badged').removeClass('not-badged');
                    $('.user-bids-counter .bracket').removeClass('show').addClass('hide');
                    $('.user-bids-counter .user-bids-count').addClass('badge').addClass('alert');
                    $('.confirm-bids-message-wrap').removeClass('show').addClass('hide');
                    $('.confirm-bids-form-wrap').removeClass('hide').addClass('show');
                    $('.confirm-bids-catalogue-section .search-counter').removeClass('hide').addClass('show');                    
                  } else {
                    $('.user-bids-counter').addClass('not-badged').removeClass('badged');
                    $('.user-bids-counter .bracket').removeClass('hide').addClass('show');
                    $('.user-bids-counter .user-bids-count').removeClass('badge').removeClass('alert');
                    $('.confirm-bids-message-wrap').removeClass('hide').addClass('show');
                    $('.confirm-bids-form-wrap').removeClass('show').addClass('hide');
                    $('.confirm-bids-catalogue-section .search-counter').removeClass('show').addClass('hide');                    
                  }
                  if (!$current_catalogue_section.hasClass('bids-catalogue-section')) {
                    $current_catalogue_item.find('.catalogue-item-user-bid').removeClass('hide').addClass('show');
                    $current_catalogue_item.find('.user-bid-string').html(parsedData.current_my_bid_string);
                    $current_catalogue_item.find('.user-bid-amount').html(parsedData.current_bid_amount_formatted);
                    $current_button_wrap.attr('data-bid-id', parsedData.new_bid_post_id);
                    $current_button_wrap.attr('data-bid-type', parsedData.current_bid_type);
                    $current_button_wrap.attr('data-bid-amount', parsedData.current_bid_amount);
                    $current_button_wrap.attr('data-bid-phone-1', parsedData.current_bid_phone1);
                    $current_button_wrap.attr('data-bid-phone-2', parsedData.current_bid_phone2);
                    $current_place_bid_button.find('.button-text').html(parsedData.current_bid_button_text);
                    $current_catalogue_item.find('.bid-type-wrap').removeClass('show').addClass('hide');
                    $current_catalogue_item.find('.bid-type-wrap-' + parsedData.current_bid_type).removeClass('hide').addClass('show');                  
                  }
                } else {
                  console.log('success error');
                }                               
              }              
            },
            complete: function() {
              $current_submit_button.removeClass('sending');
              $current_submit_button.find('.icon-spinner').remove(); 
              $("#place-bid-form").removeClass('show').addClass('hide');
              $("#place-bid-form-success").removeClass('hide').addClass('show');              
            }
          });
          return false;
        });  

        $('.place-bid-button').click(function(){
          if ($(this).hasClass('trigger-log-in-register-popup')) {
            $('#log-in-register-popup').foundation('open');
          } 
        });

        $('.bidder-logged-in .place-bid-button').click(function(){
          if ($(this).hasClass('trigger-place-bid-popup')) {
            $('#place-bid-popup').foundation('open');
          }        
          var currentUserID = $(this).closest('.user-button-wrap').attr("data-current-user-id");
          var currentItemID = $(this).closest('.user-button-wrap').attr("data-current-catalogue-item-id");
          var currentBidID = $(this).closest('.user-button-wrap').attr("data-bid-id");
          var currentTextonly = $(this).closest('.user-button-wrap').attr("data-text-only");
          var currentBidType = $(this).closest('.user-button-wrap').attr("data-bid-type");
          var currentBidAmount = $(this).closest('.user-button-wrap').attr("data-bid-amount");
          var currentBidPhone1 = $(this).closest('.user-button-wrap').attr("data-bid-phone-1");
          var currentBidPhone2 = $(this).closest('.user-button-wrap').attr("data-bid-phone-2");
          $("#place-bid-form").attr("data-current-user-id", currentUserID);
          $("#place-bid-form").attr("data-current-catalogue-item-id", currentItemID);
          $("#place-bid-form").attr("data-bid-id", currentBidID);
          $("#place-bid-form").removeClass('hide').addClass('show');
          if (currentBidPhone1 !== undefined) {
            $("#place-bid-form").attr("data-current-bid-phone-1", currentBidPhone1);
          }
          if (currentBidPhone2 !== undefined) {
            $("#place-bid-form").attr("data-current-bid-phone-2", currentBidPhone2);
          }          
          $("#bid-by-text-input").val('');
          $("#bid-by-phone-1-input").val('');
          $("#bid-by-phone-2-input").val('');
          $('#bid-by-phone-check').attr("disabled", false).prop('checked', false);
          $('#byPhoneHelpText').removeClass('show').addClass('hide');
          $('#bid-by-text-wrap').removeClass('show').addClass('hide');
          $('#bid-by-phone-wrap').removeClass('show').addClass('hide');
          $('#place-bid-form-success').removeClass('show').addClass('hide');
          if (currentTextonly === 'true') {
            $('#bid-by-text-check').prop('checked', true);
            $('#bid-by-phone-check').attr("disabled", true);
            $('#bid-by-phone-wrap').removeClass('show').addClass('hide');
            $('#byPhoneHelpText').removeClass('hide').addClass('show');
            $('#bid-by-text-wrap').removeClass('hide').addClass('show');
            $("#bid-by-text-input").prop('required', true);
          } else {
            $('#bid-by-text-check').prop('checked', false);
            $("#bid-by-text-input").prop('required', false);
          }
          if (currentBidType !== undefined) {
            $('#change-bid-button').removeClass('hide').addClass('show');
            $('#reserve-bid-button').removeClass('show').addClass('hide');
          }
          if (currentBidType === '1') {
            $('#bid-by-text-check').prop('checked', true);
            $('#bid-by-phone-wrap').removeClass('show').addClass('hide');
            $('#bid-by-text-wrap').removeClass('hide').addClass('show');
            if (currentBidAmount) {
              $("#bid-by-text-input").val(currentBidAmount);
              $("#bid-by-text-input").prop('required', true);
            }
          }   
          if (currentBidType === '2') {
            $('#bid-by-text-check').prop('checked', false);
            $('#bid-by-phone-check').attr("disabled", false).prop('checked', true);
            $('#bid-by-phone-wrap').removeClass('hide').addClass('show');
            $('#bid-by-text-wrap').removeClass('show').addClass('hide');
            if (currentBidPhone1 !== undefined) {
              $("#bid-by-phone-1-input").val(currentBidPhone1);
              $("#place-bid-form").attr("data-current-bid-phone-1", currentBidPhone1);
            }
            if (currentBidPhone2 !== undefined) {
              $("#bid-by-phone-2-input").val(currentBidPhone2);
              $("#place-bid-form").attr("data-current-bid-phone-2", currentBidPhone2);
            }                        
          }
          if (currentBidType === '3') {
            $('#bid-by-text-check').prop('checked', true);
            $('#bid-by-phone-check').attr("disabled", false).prop('checked', true);
            $('#bid-by-phone-wrap').removeClass('hide').addClass('show');
            $('#bid-by-text-wrap').removeClass('hide').addClass('show');
            if (currentBidAmount) {
              $("#bid-by-text-input").val(currentBidAmount);
              $("#bid-by-text-input").prop('required', true);
            }
            if (currentBidPhone1 !== undefined) {
              $("#bid-by-phone-1-input").val(currentBidPhone1);
              $("#place-bid-form").attr("data-current-bid-phone-1", currentBidPhone1);
            }
            if (currentBidPhone2 !== undefined) {
              $("#bid-by-phone-2-input").val(currentBidPhone2);
              $("#place-bid-form").attr("data-current-bid-phone-2", currentBidPhone2);
            }                        
          }                           
        });

        $('.bidder-logged-in #bid-by-text-check').change(function() {
           if(this.checked) {
             $('#bid-by-text-wrap').removeClass('hide').addClass('show');
             $("#bid-by-text-input").prop('required', true);
           } else {
             $('#bid-by-text-wrap').removeClass('show').addClass('hide');
             $("#bid-by-text-input").prop('required', false);
           }        
        });                     

        $('.bidder-logged-in #bid-by-phone-check').change(function() {
          var currentBidPhone1 = $(this).closest('#place-bid-form').attr("data-current-bid-phone-1");
          var currentBidPhone2 = $(this).closest('#place-bid-form').attr("data-current-bid-phone-2");
           if(this.checked) {
            $('#bid-by-phone-wrap').removeClass('hide').addClass('show');
            if (currentBidPhone1 !== undefined) {
              $("#bid-by-phone-1-input").val(currentBidPhone1);
            }
            if (currentBidPhone2 !== undefined) {
              $("#bid-by-phone-2-input").val(currentBidPhone2);
            }               
           } else {
            $('#bid-by-phone-wrap').removeClass('show').addClass('hide');
            $("#bid-by-phone-1-input").val('');
            $("#bid-by-phone-2-input").val('');             
           }        
        });  

        // Confirm bids form
        $("#confirm-bids-form").bind("submit",function(e) {
          e.preventDefault();
          return false;
        });

        $("#confirm-bids-form").bind("formvalid.zf.abide", function(e,target) {
          var currentUserID = $(this).attr("data-current-user-id");
          var formData;

          formData = $(this).serialize()
          +'&action=confirm_bids_form_action' 
          +'&currentUserID=' + currentUserID;

          $.ajax({
            url: SiteParameters.ajax_url,
            type: 'POST',
            dataType: 'html',
            data: formData,            
            beforeSend: function() {

            },
            error: function() {
              console.log('error function fired');
            },
            success: function(data) {
              if(data) { 
                var parsedData = jQuery.parseJSON(data);
                if (parsedData.status === 'success'){
                  var current_user_bids_count = parsedData.current_user_bids_count;
                  $('.user-bids-count').html(current_user_bids_count);
                  if (current_user_bids_count > 0) {
                    $('.user-bids-counter').addClass('badged').removeClass('not-badged');
                    $('.user-bids-counter .bracket').removeClass('show').addClass('hide');
                    $('.user-bids-counter .user-bids-count').addClass('badge').addClass('alert');
                  } else {
                    $('.user-bids-counter').addClass('not-badged').removeClass('badged');
                    $('.user-bids-counter .bracket').removeClass('hide').addClass('show');
                    $('.user-bids-counter .user-bids-count').removeClass('badge').removeClass('alert');
                  }                  
                  $('.confirmed-user-bids-count').html(parsedData.confirmed_user_bids_count);
                  $('.confirm-bids-catalogue-section').slideUp();
                } else {
                  console.log('success error');
                }                               
              }              
            },
            complete: function() {
              //$('#place-bid-popup').foundation('close');
              $("#confirm-bids-form").removeClass('show').addClass('hide');
              $("#confirm-bids-form-success").removeClass('hide').addClass('show');              
            }
          });
          return false;
        });

        // Remove bid
        function ajax_remove_bid (currentUserID, currentItemID) {
          var $current_remove_bid_button = $('[data-current-catalogue-item-id="' + currentItemID + '"].user-button-wrap .remove-bid-button');
          $.ajax({
            url : SiteParameters.ajax_url,
            type : 'GET',
            dataType: 'html',
            data: ({
              action: 'remove_bid',
              currentUserID: currentUserID,
              currentItemID: currentItemID,
              currentpostid: SiteParameters.post_id
            }),      
            beforeSend: function (xhr) {
              
            },
            success: function(data){
              if(data) { 
                var parsedData = jQuery.parseJSON(data);
                var current_user_bids_count = parsedData.current_user_bids_count;
                $('.confirm-bids-catalogue-section .user-button-wrap[data-current-catalogue-item-id="' + currentItemID + '"]').closest('.catalogue-item').slideUp();  
                $('.user-bids-count').html(current_user_bids_count);
                if (current_user_bids_count > 0) {
                  $('.user-bids-counter').addClass('badged').removeClass('not-badged');
                  $('.user-bids-counter .bracket').removeClass('show').addClass('hide');
                  $('.user-bids-counter .user-bids-count').addClass('badge').addClass('alert');
                  $('.confirm-bids-message-wrap').removeClass('show').addClass('hide');
                  $('.confirm-bids-form-wrap').removeClass('hide').addClass('show');
                  $('.confirm-bids-catalogue-section .search-counter').removeClass('hide').addClass('show');  
                } else {
                  $('.user-bids-counter').addClass('not-badged').removeClass('badged');
                  $('.user-bids-counter .bracket').removeClass('hide').addClass('show');
                  $('.user-bids-counter .user-bids-count').removeClass('badge').removeClass('alert');
                  $('.confirm-bids-message-wrap').removeClass('hide').addClass('show');
                  $('.confirm-bids-form-wrap').removeClass('show').addClass('hide');
                  $('.confirm-bids-catalogue-section .search-counter').removeClass('show').addClass('hide'); 
                } 
                $('.confirm-bids-catalogue-section .search-items-count').html(current_user_bids_count);                               
              }
            },
            error: function(data) {
              console.log("Error: " + data);
              return false;
            },
            complete: function() {    
              //console.log("Complete");
              $current_remove_bid_button.removeClass('sending');
              $current_remove_bid_button.find('.icon-spinner').remove();                     
            }
          });
        } 

        $('.bidder-logged-in .remove-bid-button').click(function(){
          var currentUserID = $(this).closest('.user-button-wrap').attr("data-current-user-id");
          var currentItemID = $(this).closest('.user-button-wrap').attr("data-current-catalogue-item-id");
          $(this).append( ' <i class="icon-spinner"></i>' );
          $(this).addClass('sending');
          ajax_remove_bid(currentUserID, currentItemID);
        });

        // Toggle menu
        $('[data-off-canvas]').on("opened.zf.offcanvas", function(e) {
          $('#toggle-menu').addClass('open');
          $('#main-header').addClass('toggle-menu-open');
          $('body').addClass('no-scroll toggle-menu-open');
          $('#toggle-menu-button').addClass('active');
        });
        $('[data-off-canvas]').on("closed.zf.offcanvas", function(e) {
          $('#toggle-menu').removeClass('open');
          $('#main-header').removeClass('toggle-menu-open');
          $('body').removeClass('no-scroll toggle-menu-open');
          $('#toggle-menu-button').removeClass('active');
        });

        $('#toggle-menu .menu-item-has-children > a').click(function(){
           var i = 0;
           var parent = $(this).parent();
           $('#toggle-menu ul > li').each(function(){
             if($('#toggle-menu ul > li').index(parent)!==i){
               $(this).removeClass('open');
               $(this).find('*').removeClass('open');
             }
             i++;
           });
           $(this).parent().toggleClass('open');
           $(this).toggleClass('open');
           $(this).siblings('.foldable-content').toggleClass('open');
           return false;
        });

        // Smooth scrolling
        if(window.location.hash) {
          $('html, body').animate({
              scrollTop: $(window.location.hash).offset().top - $('header').height() + 'px'
          }, 1000);
        }

        // Scrolldown Button scrolling
        $('.scrolldown-button').click(function(){
          var nextSection = $(this).closest('section').next();

          $('html, body').animate({
              scrollTop: nextSection.offset().top
          }, 1000);
        });

        function equalHeight(group) {
          var tallest = 0;
          group.css('height','auto'); //otherwise only works once!
          group.each(function() {
            var thisHeight = $(this).height();
            if(thisHeight > tallest) {
              tallest = thisHeight;
            }
          });
          group.height(tallest);
        }



        // Hoehen syncen
        if($(window).width() > 725){
         //  equalHeight($('.teaser-section .teaser-text'));
         // equalHeight($('.single-slider'));
          equalHeight($('.formular-height'));
          equalHeight($('.teaser-section .teaser-headline'));
          equalHeight($('.advantage-height'));
        }
        else {


          $('.teaser-section .teaser-text').css({'height': 'auto'});
        }

        function equalWidth(group) {
          var tallest = 0;
          group.css('width','auto'); //otherwise only works once!
          group.each(function() {
            var thisWidth = $(this).width();
            if(thisWidth > tallest) {
              tallest = thisWidth;
            }
          });
          group.width(tallest);
        }



        // managage back button click (and backspace)
        window.onpopstate = function(event) {
          if(event && event.state) {
            location.reload();
          }
        };

        window.onpopstate = function(event) {
          console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));
        };




        // Hoehen syncen
        if($(window).width() > 725){

          $('.text-section').each(function () {
            equalWidth($(".button", this));
          });

          $('.featurelist-section').each(function () {
            equalWidth($(".button", this));
          });

          equalWidth($('.header-section .button'));


        }

        else {


          $('.header-section .button').css({'width': 'auto'});
        }

          // langmenu
            $(".dropdown-lang").on("click", function(){
            $(".lang-menu, .dropdown-lang i, .dropdown-lang, .lang-menu-bg").toggleClass("active");
            $("body, html").toggleClass("noscroll");
          });

          $(".lang-menu-bg").on("click", function(){
              $(".lang-menu, .dropdown-lang i, .dropdown-lang, .lang-menu-bg").removeClass("active");
            $("body, html").removeClass("noscroll");
          });

        $(".close-button, .icon-close").on("click", function(){
          $(".lang-menu, .dropdown-lang i, .dropdown-lang, .lang-menu-bg").removeClass("active");
          $("body, html").removeClass("noscroll");
        });

// Arrow Down Scroll
        $(document).on('click', '.arrow-down', function(event){
          event.preventDefault();
          var viewportHeight = $(window).height();

          $('html, body').animate({
            scrollTop: viewportHeight + 10,
            complete: function () {
              //Hide your button here
            }
          }, 700);
        });


        // ie object-fit fallback
        function checkForIE() {
          var userAgent = window.navigator.userAgent;
          var ieReg = /msie|Trident.*rv[ :]*11\./gi;
          var ie = ieReg.test(userAgent);


          if(ie) {

            
            $(".events-video-wrapper").addClass("ie-events-video-wrapper");
            $(".events-text").addClass("ie-events-text");
            $(".slideshow-text-wrapper").each(function () {
              var $container = $(this);
              var imgUrl = $container.find("img").prop("src");
              var imgPos = $container.find("img").attr("data-object-position");
              if (imgUrl) {
                $container.css("backgroundImage", 'url(' + imgUrl + ')').addClass("ie-object-fit");
                if (imgPos) {
                  $container.css("background-position", imgPos);
                }
              }
            });
            //$(".home .single-slider div").each(function () {
            //  var $container = $(this);
            //  var imgUrl = $container.find("img").prop("src");
            //  var imgPos = $container.find("img").attr("data-object-position");
            //  if (imgUrl) {
            //    $container.css("backgroundImage", 'url(' + imgUrl + ')').addClass("ie-object-fit-highlights");
            //    if (imgPos) {
            //      $container.css("background-position", imgPos);
            //    }
            //  }
            //});
          }
        }
        checkForIE();








        if( /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent) ) {
          $('.events-video-wrapper video').remove()

          $(".events-video-wrapper video").hide();
          $(".events-video-wrapper .video-thumbnail").show();
        }
        else {
          $(".events-video-wrapper video").show();
          $(".events-video-wrapper .video-thumbnail").hide();
        }





        // cookie disclainer
        var cookieBox = document.getElementById('js-cookie-box');
        var cookieButton = document.getElementById('js-cookie-button');

        if (!Cookies.get('cookie-box')) {

          cookieBox.classList.remove('cookie-box--hide');

          $(".close-cookie-button").on("click", function(){
            Cookies.set('cookie-box', true, { expires: 7 });
            cookieBox.classList.add('cookie-box--hide');
          });
        }

        // fire initial resize
        $(window).trigger('resize');

      },
      finalize: function() {
        $(window).trigger('resize');
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
      resize: function() {

        var headerHeight = $('#main-header').outerHeight(true);
        var footerHeight = $("#footer-wrap").outerHeight(true);
        var windowHeight = $(window).height();
        var combinedHeight = windowHeight - footerHeight;

        if( /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent) ) {
          $(".events-video-wrapper video").hide();
          $(".events-video-wrapper .video-thumbnail").show();
        }
        else {
          $(".events-video-wrapper video").show();
          $(".events-video-wrapper .video-thumbnail").hide();
        }


          function equalHeight(group) {
              var tallest = 0;
              group.css('height','auto'); //otherwise only works once!
              group.each(function() {
                  var thisHeight = $(this).height();
                  if(thisHeight > tallest) {
                      tallest = thisHeight;
                  }
              });
              group.height(tallest);
          }



          // Hoehen syncen!!
          if($(window).width() > 725){
            //  equalHeight($('.teaser-section .teaser-text'));
          //  equalHeight($('.single-slider .testimonal-quote'));
            equalHeight($('.formular-height'));
            equalHeight($('.teaser-section .teaser-headline'));
            equalHeight($('.advantage-height'));
          }
          else {


              $('.teaser-section .teaser-text').css({'height': 'auto'});
          }



        // Sliders
        var resizeSliders = null;

        clearTimeout(resizeSliders);
        resizeSliders = setTimeout(
          function() {
            function renderCounter(slick,carouselId) {
              var slidesToShow;
              if(slick.activeBreakpoint!==null){
                slidesToShow = slick.breakpointSettings[slick.activeBreakpoint].slidesToShow;
              } else {
                slidesToShow = slick.options.slidesToShow;
              }

              if($('#'+carouselId).parents('.slider-wrapper').find('.slick-next').length>0){
                $('#'+carouselId).parents('.slider-wrapper').find('.counter').html( (slick.currentSlide+slidesToShow)/slidesToShow +' / ' + Math.ceil((slick.slideCount)/slidesToShow));
                $('#'+carouselId).parents('.slider-wrapper').find('.slider-control').show();
              } else {
                $('#'+carouselId).parents('.slider-wrapper').find('.counter').html('');
                $('#'+carouselId).parents('.slider-wrapper').find('.slider-control').hide();
              }
            }

            $('.common-slider').each(function (idx, item) {
              if ($(this).hasClass('slick-initialized')) {
                  $(this).slick('resize');
              } else {
                var carouselId = "carousel_" + idx;
                this.id = carouselId;
                $(this).attr('data-counter','carousel_slick-control_' + idx);
                $(this).next('.slider-control').attr('id','carousel_slick-control_' + idx);

                $(this).on('init', function(event, slick) {
                  //console.log('init');
                });

                $(this).on('setPosition', function(event, slick) {
                  //console.log('setPosition');
                  renderCounter(slick,carouselId);
                });

                $(this).on('afterChange', function(event, slick, currentSlide){
                  //console.log('afterChange');
                });

                $(this).on('edge', function(event, slick, direction){
                  //console.log('edge was hit');
                });

                $(this).slick();

              }
            });

          },
          400
        );


        $(".section-headline:contains(' // ')").html(function(_, html) {
          return  html.replace(/\/{2,}/g, ' <span class="icon-typosign"></span> ');
        });

        // replace double slashes with icon
        function replace_slashes() {




          $(".section-headline:contains(' // ')").html(function(_, html) {
            return  html.replace(/\/{2,}/g, ' <span class="icon-typosign"></span> ');
          });

          $("section .post-item-hover-text:contains(' // ')").html(function(_, html) {
            return  html.replace(/\/{2,}/g, ' <span class="icon-typosign"></span> ');
          });
          $("section .post-item-hover-name:contains(' // ')").html(function(_, html) {
            return  html.replace(/\/{2,}/g, ' <span class="icon-typosign"></span> ');
          });
        }


        // Load ajax posts
        function load_ajax_posts () {
            var settingsKey = $(this).attr('data-posts-selector-index');
            var currentPostID = $(this).attr('data-posts-selector-current-post-id');

            var currentManualTeaserArray = $(this).attr('data-posts-selector-manual-teaser-array');
            var currentCategory = $(this).attr('data-posts-selector-category');
            var currentTag = $(this).attr('data-posts-selector-tag');
            var currentHowManyTeasers = $(this).attr('data-posts-selector-how-many-teasers');
            var currentNumRowsMobile = $(this).attr('data-posts-selector-num-rows-mobile');
            var currentNumRowsDesktop = $(this).attr('data-posts-selector-num-rows-desktop');

            var currentPostCount = $(this).find('.load-more').attr('data-load-more-current-post-count');
            var currentOffset = $(this).find('.load-more').attr('data-load-more-current-offset');

            var currentPostsPerPage = -1;
            var currentMediaquery = '';

            if (currentHowManyTeasers !== 'all') {
              if (Foundation.MediaQuery.is('small only')) {
                  currentPostsPerPage = currentNumRowsDesktop;
              }
              if (Foundation.MediaQuery.is('medium only')) {
                  currentPostsPerPage = currentNumRowsDesktop * 1;
              }
              if (Foundation.MediaQuery.is('large only')) {
                  currentPostsPerPage = currentNumRowsDesktop * 1;
              }
              if (Foundation.MediaQuery.atLeast('xlarge')) {
                  currentPostsPerPage = currentNumRowsDesktop * 1;
              }
            }

            if (Foundation.MediaQuery.is('small only')) {
                currentMediaquery = 'small';
            }
            if (Foundation.MediaQuery.is('medium only')) {
                currentMediaquery = 'medium';
            }
            if (Foundation.MediaQuery.is('large only')) {
                currentMediaquery = 'large';
            }
            if (Foundation.MediaQuery.atLeast('xlarge')) {
                currentMediaquery = 'xlarge';
            }

            if (!($('.posts-selector-multiple-' + settingsKey).hasClass('loader-loading'))) {

              $.ajax({
                type: "GET",
                url: SiteParameters.ajax_url,
                dataType: 'html',
                data: ({
                  action: 'load_responsive_posts',
                  currentsettingskey: settingsKey,
                  currentpostid: currentPostID,
                  currentpostsperpage: currentPostsPerPage,
                  currentmediaquery: currentMediaquery,
                  currentmanualteaserarray: currentManualTeaserArray,
                  currentcategory: currentCategory,
                  currenttag: currentTag,
                  currentpostcount: currentPostCount,
                  currentoffset: currentOffset
                }),
                beforeSend : function () {
                  $('.posts-selector-multiple-' + settingsKey).addClass('loader-loading');
                },
                success: function(data) {
                  if(data) {
                    if ( $('#load-more-' + settingsKey).length > 0 ) {
                      $('#load-more-' + settingsKey).replaceWith(data);
                    } else {
                      $('.posts-selector-multiple-' + settingsKey).prepend(data);
                    }





                    replace_slashes();

                  } else {
                    console.log("no data");
                  }
                },
                error: function(data) {
                  console.log("Error :( " + data);
                  return false;
                },
                complete:   function() {
                  replace_slashes();




                   /* $('.post-items').masonry({
                      // options
                      itemSelector : '.grid-item',
                      columnWidth: '.grid-sizer',
                      gutterWidth: 20
                    }).masonry('reload');

                  }  , 5000 ); */


                  $('.posts-selector-multiple-' + settingsKey).removeClass('loader-loading');
                  // Trigger event after the posts are loaded
                  var loadResponsivePostsCompleteEvent = new Event('loadResponsivePostsComplete');
                  document.dispatchEvent(loadResponsivePostsCompleteEvent);
                }
              });
            }




            return false;
        }

        var resizeMorePosts = null;
        clearTimeout(resizeMorePosts);
        resizeMorePosts = setTimeout(
          function() {
            var numSlides = $('.slick-dots li').length;
            $( ".slick-dots li:last-child" ).after( '<span class="total"> / '+ numSlides +'</span>' );
            $('.slick-prev').appendTo(".slick-dots");
            $('.slick-next').appendTo(".slick-dots");

            $('.news-section .post-item-wrap').each(function(){
              $(this).remove();
            });
            $('.news-section .load-more').each(function(){
              $(this).remove();
            });
            $.each($('.posts-selector-multiple'), load_ajax_posts);
          },
          400
        );


        $(".posts-selector-multiple").on('click', 'button.load-more', function() {
          var currentParent = $(this).closest('.posts-selector-multiple');
          $.each(currentParent, load_ajax_posts);
        });

        document.addEventListener('loadResponsivePostsComplete', function(e) {
          //console.log("loadResponsivePostsComplete");
        }, false);

        // Sticky footer
        function stickyFooter() {
          if (Foundation.MediaQuery.atLeast('large')) {
            $("main.main").css('min-height', combinedHeight + "px");
          } else {
            $("main.main").css('min-height', "100vh");
          }
        }

        if ($( "#footer-wrap" ).length) {
          stickyFooter();
        }

      },
      windowload: function() {

        function slideNumber() {
          var $slides = $('.orbit-slide');
          var $activeSlide = $slides.filter('.is-active');
          var activeNum = $slides.index($activeSlide) + 1;
          $('.slide-number').html(activeNum);
          //console.log(activeNum);
        }
        $('[data-orbit]').on('slidechange.zf.orbit', slideNumber);


        //console.log('loaded');
        $('html').addClass('window-loaded');
      }
    },
    // Home page
    'home': {
      init: function() {

        jQuery(function($) {

          var $nav = $('#main-header');
          var $win = $(window);
          var winH = $win.height();

          $win.on("scroll", function () {
            if ($(this).scrollTop() > winH ) {
              $nav.addClass("teaser-header");
            } else {
              $nav.removeClass("teaser-header");
            }
          }).on("resize", function(){
            winH = $(this).height();
          });

        });
        // JavaScript to be fired on the home page

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

      },
      resize: function() {





      },
      windowload: function() {

      }
    },
    'page_template_template_layouts': {
      init: function() {

      },
      finalize: function() {

      },
      resize: function() {

      },
      windowload: function() {

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
        //UTIL.fire(classnm, 'resize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
      //UTIL.fire('common','resize');
    },
    resizeEvents: function() {

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'resize');
      });

      UTIL.fire('common','resize');

    },
    windowLoadEvents: function() {

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm, 'windowload');
      });

      UTIL.fire('common','windowload');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
  $(window).on("load",UTIL.windowLoadEvents);

  // Resize Events
  var trackWindowWidth = $(window).width();

  $(window).resize(function (trackResizeEvent) {
      //console.log(!trackResizeEvent.isTrigger ? ' resize' : ' triggerd');

      // Check window width has actually changed and it's not just iOS triggering a resize event on scroll || the resize event was caused by $(window).trigger('resize');
      if (($(window).width() !== trackWindowWidth) || trackResizeEvent.isTrigger) {
          // Update the window width for next time
          trackWindowWidth = $(window).width();

          UTIL.resizeEvents();
      }
  });


})(jQuery); // Fully reference jQuery after this point.

